<template>
  <div id="main-container">
    <div>
      <!---Navigation-->
      <!-- <Navbar
        :topbarColor="topbarColor"
        :logo="this.imgLogo"
        :widthLogo="this.widthLogo"
      /> -->
      <Navbar-2 :logo="this.imgLogo" :ondark_mode="dark_mode" />

      <!---Sidebar-->
      <!-- <SideBar
        v-if="outRounterView.indexOf(this.$route.path) == -1"
        parent=".main-wrapper"
        :sidebarLinks="sidebarLinks"
        :sidebarLinks_dashboard="sidebarLinks_dashboard"
      /> -->
      <SideBar2
        parent=".main-wrapper"
        :sidebarLinks="sidebarLinks"
        :sidebarLinks_dashboard="sidebarLinks_dashboard"
      />
    </div>

    <!---Page Container-->
    <div class="main-container-fluid" :class="classObject">
      <router-view :key="$route.path"></router-view>
      <footer
        style="
          margin-top: 15px;
          text-align: center;
          font-size: 13px;
          color: #aaa;
          margin-bottom: 0;
        "
        v-if="this.user === 'Rivacold01' || this.admin === 'Rivacold01'"
      >
        <p>
          ฝ่ายบริการ ติดต่อ Line official : @rivacoldservice โทร :
          02-116-8489-90, 081-456-4836, 089-413-3474, 098-262-7108, 098-262-7109
        </p>
        <!-- <p><a href="mailto:hege@example.com">hege@example.com</a></p> -->
      </footer>
      <footer
        style="
          margin-top: 15px;
          text-align: center;
          font-size: 13px;
          color: #aaa;
          margin-bottom: 0;
        "
        v-else-if="this.user === 'hinoIT' || this.admin === 'hinoIT'"
      >
        <p>
          Pawarut Norajit Technician Support Team : Pawarut_n@hinothailand.com
          โทร : 02-927-5348 #185
        </p>
        <!-- <p><a href="mailto:hege@example.com">hege@example.com</a></p> -->
      </footer>
    </div>

    <b-modal
      ref="my-modal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div class="d-block text-center">
        <div>
          <img
            style="width: 80%"
            src="@/assets/images/big/customerSatisfaction.png"
          />
        </div>
        <br />
        <h2 class="style1">We'd welcome your feedback</h2>
        <br />
        <h5>
          By answering this 3 minute feedback, you'll help us further improve
          our service.
        </h5>
        <vs-button
          class="mt-3 btn_feedback"
          to="/CustomerSatisfactionForm"
          color="#0069d9"
          type="filled"
          ><h5 style="border">Sure,I'll give feedback</h5></vs-button
        >

        <b-button class="mt-2 mb-4" variant="link" block @click="hideModal"
          ><h5>No thanks</h5></b-button
        >
        <h6>
          Powered by
          <img
            style="width: 15%"
            src="@/assets/images/logo/swift_logo (1).png"
          />
        </h6>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Navbar from "@/layout/full/header/Navbar.vue";
import SideBar from "@/layout/full/sidebar/SideBar.vue";
import sidebarLinks from "@/layout/full/sidebar/sidebarlinks.js";
import sidebarLinks_dashboard from "@/layout/full/sidebar/sidebarlinks_dashboard.js";
import Navbar2 from "./header/Navbar2.vue";
import SideBar2 from "./sidebar/SideBar2.vue";

import { io } from "socket.io-client";

export default {
  name: "MainContainer",
  components: {
    Navbar,
    SideBar,
    Navbar2,
    SideBar2,
  },
  data: () => ({
    popupActivo: false,
    topbarColor: "#ffffff",
    logotitle: "SwiftOneIoT",
    sidebarLinks: sidebarLinks,
    sidebarLinks_dashboard: sidebarLinks_dashboard,
    interval: "",
    isActive: "main-container-fluid",
    Active: "main-container-fluid-lg",
    user: "",
    imgLogo: "",
    widthLogo: "",
    admin: "",
    outRounterView: ["/login", "/reset", "/Resetpassword", "/register"],
    kubotaPage: [
      "/kubotafarmOverview",
      "/kubotafarmSolar",
      "/kubotafarmRice",
      "/kubotafarmPlant3",
      "/kubotafarmPlant4",
      "/kubotafarmPlant5",
      "/kubotafarmPlant6",
      "/kubotafarmPlant7",
      "/kubotafarmPlant8",
    ],
    socket: undefined,
    dark_mode: true,
  }),
  methods: {
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    checkin() {
      this.interval = setTimeout(() => {
        this.$API
          .post("checkin", {
            username: this.$session.get("username"),
          })
          .then(() => {
            this.checkin();
          })
          .catch((err) => {
            // console.log(err)
          });
      }, 30000);
    },
  },
  computed: {
    classObject: function () {
      if (!this.$store.state.isSidebarActive) {
        return this.isActive;
      } else {
        return this.Active;
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.interval);
    // this.$WSS.socket().disconnect();
  },
  mounted() {
    // var connection = new WebSocket("ws://18.140.161.60:4000");
    // connection.onopen = function () {
    //   // จะทำงานเมื่อเชื่อมต่อสำเร็จ
    //   console.log("connect webSocket");
    //   connection.send("Hello ABCDEF"); // ส่ง Data ไปที่ Server
    //   connection.send("fuck you server"); // ส่ง Data ไปที่ Server

    // };
    // connection.onerror = function (error) {
    //   console.error("WebSocket Error " + error);
    // };
    // connection.onmessage = function (e) {
    //   // log ค่าที่ถูกส่งมาจาก server
    //   // console.log("message from server: ", e.data);
    //   // createDivElement(e.data);
    // };
    // function createDivElement(data) {
    //   var newDiv = document.createElement("div");
    //   newDiv.setAttribute("id", "myDiv");
    //   newDiv.innerHTML = data;
    //   document.body.appendChild(newDiv);
    // }

    // console.log("connect wss");
    // this.socket = io("http://18.140.161.60:4000/yamaha", {
    //   transports: ["websocket", "polling"],
    //   withCredentials: true,
    //   extraHeaders: {
    //     "my-custom-header": "abcd",
    //   },
    // });
    // this.socket.emit("yamaha", {
    //   userToken: {
    //     req: {
    //       headers: {
    //         authorization:
    //           "Bearer " +
    //           this.$session.get("accessToken"),
    //       },
    //     },
    //   },
    //   message: "message",
    // });

    // this.socket.on("yamaha", (messageNew) => {
    //   this.socket.io.opts.transports = ["polling", "websocket"];
    //   console.log("messageNew", messageNew,this.$moment().format("HH:mm:ss"));
    //   // temp.push(messageNew)
    //   // this.setState({ message: temp })
    // });
    // this.socket.on("connect", () => {
    //   console.log("socket id",this.socket.id);
    // });

    // this.socket.on("message", (msg) => {
    //   console.log(msg);
    // });
    // this.socket.on("disconnect", () => {
    //   console.log(socket.id); // undefined
    // });

    // console.log(this.$route.path);
    // console.log("dekfol");
    // console.log(this.$session.get("accessToken"));
    this.user = this.$session.get("username");
    this.admin = this.$session.get("admin");

    switch (this.user || this.admin) {
      case "betagrodemo":
        // console.log("betagrodemo");
        // var elem = document.getElementsByClassName("b");
        // Array.prototype.filter.call(elem, function (testElement) {
        //   testElement.style.background = "black";
        // });
        var elem1 = document.getElementsByClassName("main-container-fluid");
        Array.prototype.filter.call(elem1, function (testElement1) {
          testElement1.style.background = "black";
        });
        this.imgLogo = require("@/assets/images/logo/sentenance_logo_WH.png");
        this.widthLogo = "200px";
        this.dark_mode = false;
        break;
      case "encodemo":
        // console.log("encodemo");
        this.imgLogo = require("@/assets/images/logo/Untitled design (2).png");
        this.widthLogo = "120px";
        this.dark_mode = false;

        break;
      case "birchteladmin":
      case "nt":
      case "sbr":
        // console.log("encodemo");
        this.imgLogo = require("@/assets/images/logo/nt_logo.jpg");
        this.widthLogo = "300px";
        this.dark_mode = false;

        break;
      case "Rivacold01":
        // console.log("Rivacold01");
        this.imgLogo = require("@/assets/images/rivacold/logo_rivacold_png.png");
        this.widthLogo = "200px";
        this.dark_mode = false;

        break;

      case "FPSadmin":
      case "FPSmanage":
      case "FPSoperator":
        // console.log("Rivacold01");
        this.imgLogo = require("@/assets/images/NikhomLatKrabang/logo_FPS2.png");
        this.widthLogo = "400px";
        this.dark_mode = false;

        break;
      case "QCONdemo":
        // console.log("Rivacold01");
        this.imgLogo = require("@/assets/images/logo/logo Q-CON now.jpg");
        this.widthLogo = "500px";
        this.dark_mode = false;

        break;
      case "kubotademo":
        // console.log("kubotademo");
        this.imgLogo = require("@/assets/images/kubota/LOGO KUBOTA 2018 (2).png");
        this.widthLogo = "160px";
        this.dark_mode = false;

        break;
      case "yamahademo":
      case "yamahauser":
      case "yamahaguest":
      case "yamahaaqidemo":
        // console.log("yamahademo");
        this.imgLogo = require("@/assets/images/gif Yamaha/logo.png");
        this.widthLogo = "200px";
        this.dark_mode = true;

        break;
      case "hinoIT":
        // console.log(this.$store.getters["mode"]);
        // if (this.$session.get('mode') == "light_mode") {
        this.imgLogo = require("@/assets/images/logo/hino-logo1.png");
        // } else {
        //   this.imgLogo = require("@/assets/images/logo/sentenance_logo.png");
        // }
        this.widthLogo = "200px";
        this.dark_mode = false;

        break;
      
      case "awcdemo":
        // console.log("yamahademo");
        this.imgLogo = require("@/assets/images/asset-world/asset-world-logo.png");
        this.widthLogo = "200px";
        // this.dark_mode = true;

        break;

      default:
        // console.log("Try looking up for a hint.");
        this.imgLogo = require("@/assets/images/logo/sentenance_logo.png");
        this.widthLogo = "200px";
        this.dark_mode = true;
    }
    switch (this.admin) {
      case "Rivacold01":
        // console.log("Rivacold01");
        this.imgLogo = require("@/assets/images/rivacold/logo_rivacold_png.png");
        this.widthLogo = "200px";
        this.dark_mode = false;
        break;
      case "hinoIT":
        // console.log(this.$store.getters["mode"]);
        // if (this.$session.get('mode') == "light_mode") {
        this.imgLogo = require("@/assets/images/logo/hino-logo1.png");
        // } else {
        //   this.imgLogo = require("@/assets/images/logo/sentenance_logo.png");
        // }
        this.widthLogo = "200px";
        this.dark_mode = false;
        break;
      case "yamahademo":
        // console.log("yamahademo");
        this.imgLogo = require("@/assets/images/gif Yamaha/logo.png");
        this.widthLogo = "200px";
        this.dark_mode = true;

        break;
    }
    // this.showModal();
  },
  created() {
    this.user = this.$session.get("username");
    this.admin = this.$session.get("admin");
    this.checkin();
  },
};
</script>
<style  scoped>
.btn_feedback {
  width: 80%;
  border-radius: 20px;
}
.style1 {
  font-weight: 550;
}
</style>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Prompt&family=Roboto&display=swap");

body {
  font-family: "Roboto", "Prompt", sans-serif;
}
</style>